module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_20.99932b6b.jpg";